<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="administrative">1. Administrative</h2>
        <div v-if="loaded">
         
          <template v-if="factsheet.data.gadm_summary.gadm_level0.length == 1">
            <p>
            The area of interest is located in {{factsheet.data.gadm_summary.gadm_level0[0].country_name}}, and overlaps the Level 1 administrative divisions of {{ andList(factsheet.data.gadm_summary.gadm_level1[factsheet.data.gadm_summary.gadm_level0[0].country_name], attr='adm1_name', attrpercent='adm1_overlap') }}.
            [<a href="#ref-1">1</a>]
            </p>
          </template>
          <template v-if="factsheet.data.gadm_summary.gadm_level0.length == 2">
            <p>
              The area of interest is located on the border of {{factsheet.data.gadm_summary.gadm_level0[0].country_name}} and {{factsheet.data.gadm_summary.gadm_level0[1].country_name}}, with {{factsheet.data.gadm_summary.gadm_level0[0].adm0_overlap}}% of it in {{factsheet.data.gadm_summary.gadm_level0[0].country_name}}, and {{factsheet.data.gadm_summary.gadm_level0[1].adm0_overlap}}% in {{factsheet.data.gadm_summary.gadm_level0[1].country_name}}.

              <template v-for="country in factsheet.data.gadm_summary.gadm_level0">
                The area in {{country.country_name}} overlaps the Level 1 administrative divisions of {{ andList(factsheet.data.gadm_summary.gadm_level1[country.country_name], attr='adm1_name', attrpercent='adm1_overlap') }}.
              </template>
              [<a href="#ref-1">1</a>]
            </p>
          </template>
          <template v-if="factsheet.data.gadm_summary.gadm_level0.length > 2">
            <p>
            The area of interest is located in the following countries: 

            {{ andList(factsheet.data.gadm_summary.gadm_level0, attr='country_name', attrpercent='adm0_overlap') }}.
            [<a href="#ref-1">1</a>]
            </p>
          </template>

        </div>
      </div>
    </div>


    <div class="row row-eq-height">
      <div class="col">
        <AdministrativeMap 
          background="ckg19vj6j2yv719nieoymrgaq" 
          source="gadm_level1_simplified.geojson" 
          download="/gadm_summary/gadm_level1.geojson" 
          title="Administrative Divisions (Level 1)" 
          attribution="Background: Mapbox/Openstreetmap Contributors. Data: GADM [1]" 
          label="adm1_name"
          sublabel="adm1_type"
          v-bind:location="location"
          v-bind:factsheet="factsheet"
          v-bind:loaded="loaded">
          <p>
            Level 1 Administrative divisions that overlap the area of interest.
          </p>
        </AdministrativeMap>
      </div>
      <div class="col">
        <AdministrativeMap 
          background="ckg19vj6j2yv719nieoymrgaq" 
          source="gadm_level2_simplified.geojson" 
          download="/gadm_summary/gadm_level2.geojson" 
          title="Administrative Divisions (Level 2)" 
          label="adm2_name"
          sublabel="adm2_type"
          attribution="Background: Mapbox/Openstreetmap Contributors. Data: GADM [1]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet"
          v-bind:loaded="loaded">
          <p>
            Level 2 Administrative divisions that overlap the area of interest.
          </p>
        </AdministrativeMap>
      </div>
    </div>


  </div>
</template>

<script>
    /* eslint-disable */
    import _ from 'lodash';
    import AdministrativeMap from '@/components/factsheet/maps/AdministrativeMap.vue'

    export default {
        name: 'Intro',
        components: { AdministrativeMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        methods: {
          andList(list, attr, attrpercent) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return list[i][attr]+percent
              }
              if(i == list.length-1) {
                ret += " and "+list[i][attr]+percent
              } else {
                ret += list[i][attr]+percent+", "
              }
            }
            return ret
          }
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>